import { FC } from 'react';
import { CodeEditor, DescriptionBlock } from '../../../../../../common/components';
import { PageLayout } from '../../../../entities';
import { CommonDrawerTitle } from '../../../../../../common/layouts';
import { Button, Popconfirm, Space, theme } from 'antd';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../../../../../../common/interfaces';
import { ExclamationCircle, PencilSquare, Trash } from 'react-bootstrap-icons';

interface Props {
  layout: PageLayout;
  disableControlButtons: boolean;
  isDeleteLayoutLoading: boolean;
  handleDeleteLayout: () => void;
}

export const PageLayoutsViewView: FC<Props> = ({ layout, disableControlButtons, isDeleteLayoutLoading, handleDeleteLayout }) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Link to={ AppRoutes.PageLayoutsByIdEdit.replace(':siteId', layout.site.id).replace(':layoutId', layout.id) }>
              <Button type="default" icon={ <PencilSquare/> } disabled={ disableControlButtons }>
                Редагувати
              </Button>
            </Link>
            <Popconfirm
              destroyTooltipOnHide
              title="Видалити макет"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              description="Ви дійсно хочете видалити цей макет?"
              onConfirm={ handleDeleteLayout }
              okText="Так, видалити"
              okButtonProps={{ danger: true }}
              cancelText="Ні"
              placement="left"
              disabled={ disableControlButtons }
            >
              <Button
                type="primary"
                danger
                icon={ <Trash/> }
                disabled={ disableControlButtons }
                loading={ isDeleteLayoutLoading }
              >
                Видалити
              </Button>
            </Popconfirm>

          </Space>
        }
      />

      <DescriptionBlock
        items={ [
          ['Назва', layout.name]
        ] }
      />

      <DescriptionBlock
        items={ [
          ['Вміст', <CodeEditor key={ 'layout.content' } value={ layout.content } disableMinimap readOnly height={ 600 }/>]
        ] }
      />

    </>
  );
};
